import {
  Scene,
  Mesh,
  MeshBuilder,
  StandardMaterial,
  Color3,
  Vector3,
} from '@babylonjs/core';
import { BlockRegistry } from '../voxel/BlockRegistry';
import { Block } from '../voxel/Block';

export class BuildPreview {
  private previewMesh: Mesh;
  private material: StandardMaterial;
  private registry: BlockRegistry;

  private isVisible: boolean = false;
  private currentBlockId: number = Block.GRASS;

  constructor(scene: Scene) {
    this.registry = BlockRegistry.getInstance();

    // Create preview mesh
    this.previewMesh = MeshBuilder.CreateBox('buildPreview', { size: 1.01 }, scene);

    // Create semi-transparent material
    this.material = new StandardMaterial('buildPreviewMat', scene);
    this.material.alpha = 0.5;
    this.material.diffuseColor = new Color3(0.3, 0.7, 0.2);
    this.material.specularColor = new Color3(0, 0, 0);
    this.material.backFaceCulling = false;

    this.previewMesh.material = this.material;
    this.previewMesh.isPickable = false;
    this.previewMesh.setEnabled(false);
  }

  public show(position: Vector3, blockId: number): void {
    // Position at block center
    this.previewMesh.position = new Vector3(
      position.x + 0.5,
      position.y + 0.5,
      position.z + 0.5
    );

    // Update color based on block type
    if (blockId !== this.currentBlockId) {
      this.currentBlockId = blockId;
      const blockDef = this.registry.get(blockId);
      if (blockDef) {
        this.material.diffuseColor = blockDef.color.clone();
      }
    }

    if (!this.isVisible) {
      this.previewMesh.setEnabled(true);
      this.isVisible = true;
    }
  }

  public hide(): void {
    if (this.isVisible) {
      this.previewMesh.setEnabled(false);
      this.isVisible = false;
    }
  }

  public setBlockId(blockId: number): void {
    this.currentBlockId = blockId;
    const blockDef = this.registry.get(blockId);
    if (blockDef) {
      this.material.diffuseColor = blockDef.color.clone();
    }
  }

  public getBlockId(): number {
    return this.currentBlockId;
  }

  public isShowing(): boolean {
    return this.isVisible;
  }

  public dispose(): void {
    this.material.dispose();
    this.previewMesh.dispose();
  }
}
